export default `
    <span id="#= data.id #" class="util-container #= data.containerClasses || "" #">
        <span class="util-icon #= data.iconType #">
        # if (data.iconType == 'tech' || data.iconType == 'small-tech') { #
            <i class="fas tech-badge"></i>
        # } #
        </span>
        <span class="util-label bind-label" data-bind="text: #= data.bindValue #"></span>
        <span class="util-bug badge" style="display: none;">1</span>
    </span>
`;
